import React from "react";
import {
  CampaignHeader,
  CampaignCost,
  CollapseHeader,
  CollapsePrice,
  CollapseIcon
} from "../BookingOverview.styled";
import { HelpIcon, IconArrowDown } from "../../../../../Components/Icons";
import { Tooltip } from "../../../../../Components/Overlays";

export const BookingCollapse = ({ collapse, title, dataTip, cost }) => {
  return (
    <CollapseHeader collapse={!collapse}>
      <CampaignHeader inCollapse>
        {title}
        {dataTip && (
          <Tooltip bgColor="#000" label={dataTip} enabled={dataTip}>
            <HelpIcon color="#7A89F4" size="15" />
          </Tooltip>
        )}
      </CampaignHeader>

      <CollapsePrice>
        {cost != null && <CampaignCost hide={collapse}>{cost} €</CampaignCost>}
        <CollapseIcon rotateIcon={collapse}>
          <IconArrowDown />
        </CollapseIcon>
      </CollapsePrice>
    </CollapseHeader>
  );
};
